<template>
    <div>
        <v-dialog 
        v-model="dialog" 
        max-width="800px"> 
            <v-btn 
            fab dark small depressed slot="activator" class="primary"
            >
            <v-icon dark>add</v-icon>
            </v-btn>

            <v-card>
                <v-card-title>
                    <h2>Create a New User</h2>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation
                        >
                        <v-layout wrap>

                            <v-flex xs6>
                                <v-text-field 
                                    v-model="name" 
                                    label="Name"
                                    :rules="nameRules" 
                                    required>
                                </v-text-field>
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field 
                                    v-model="lastname" 
                                    label="Last name"
                                    :rules="lastnameRules" 
                                    required>
                                </v-text-field>
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field 
                                    v-model="email"  
                                    label="Email" 
                                    :rules="emailRules"
                                    required>
                                </v-text-field>
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field 
                                    v-model="password" 
                                    label="Password"
                                    :rules="passwordRules" 
                                    required>
                                </v-text-field>
                            </v-flex>
                            <v-flex xs6>
                                <v-subheader v-text="'is User and Admin?'"></v-subheader>
                            </v-flex>
                            <v-flex xs6>
                                <v-select
                                v-model="adminType"
                                :items="isAdmin"
                                label="Is Admin?"
                                solo
                                :rules="isAdminRules"
                                required></v-select>
                            </v-flex>
                            <v-flex xs12>

                            </v-flex>
                            <v-flex xs12>
                                <v-select
                                    :items='clientsNames'
                                    v-model='selectedClients'
                                    multiple
                                    chips
                                    label="Clients"
                                ></v-select>
                            </v-flex>
                            <v-flex x6>
                                <v-select
                                    :items='selectedClients'
                                    v-model='ownedClients'
                                    multiple
                                    chips
                                    label="Owned Clients"
                                ></v-select>
                            </v-flex>
                        </v-layout>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>
                    <v-btn :disabled="!valid" color="blue darken-1" flat @click="_createUser">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <span class="subheading">Create New User</span>
    </div>
            
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
        data(){
            return{
                selectedClients:[

                ],
                clientsID: [

                ],
                clientsNames: [

                ],
                clientsNamesAndIDs: [

                ],
                ownedClients : [

                ],
                isAdmin: [false, true],
                adminType: false, //initially false
                isAdminRules: [
                    v => !null || 'Admin type is required'
                ],
                valid: true,
                dialog : false,
                name:'',
                nameRules: [
                    v => !!v || 'Name is required',
                ],
                lastname: '',
                lastnameRules : [
                    v => !!v || 'Lastname is required',
                ],
                email: '',
                emailRules: [
                    v => !!v || 'E-mail is required',
                    v => /.+@.+/.test(v) || 'E-mail must be valid'
                ],
                password: '',
                passwordRules: [
                    v => !!v || 'Password is required',
                    v => v.length > 5 || 'Password length should be at least 6 characters'
                ]
            }
        },
        computed: {
            ...mapGetters([
                'allClients'
            ])
        },
        beforeMount(){
            this.getClientsNamesAndIDs(this.allClients);
         },
         mounted(){
            //  this.createUser();
            this.clearForm();
         }, 
        methods: {
            ...mapActions([
                'createUserAuth',
            ]),
            // Trigger method before mount
            getClientsNamesAndIDs(allClients){
                allClients.forEach(client => {
                    // console.log(client)
                        this.clientsNames.push(client.name)
                        this.clientsID.push(client.id)
                        this.clientsNamesAndIDs.push(
                            {
                                name: client.name,
                                id: client.id
                            }
                        )        
                })      
            },
            _createUser: function(){  
                // if form is valid
                if (this.$refs.form.validate()) {
                    this.snackbar = true
                    console.log(`_createUser email: ${this.email}`)
                    // adding user to collection returns a reference to the user document
                    this.createUserAuth({
                    name:this.name,
                    email: this.email,
                    isAdmin: this.adminType,
                    lastname: this.lastname,
                    selectedClients:this.selectedClients,
                    clientsNamesAndIDs: this.clientsNamesAndIDs,
                    ownedClients: this.ownedClients,
                    password: this.password
                    })
                    .then(()=>{
                        // after creation, close create user dialog
                        this.dialog = false
                    })
                }    
            },
            clearForm(){
                this.name = ''
                this.lastname = ''
                this.email = ''
                this.selectedClients = []
                this.clientsID = []
            },
            validate () {
                if (this.$refs.form.validate()) {
                    this.snackbar = true
                }
            },
            reset () {
                this.$refs.form.reset()
            },
            resetValidation () {
                this.$refs.form.resetValidation()
            }
        }
             
}
</script>